import { StreamActions } from "@hotwired/turbo"

// Custom Turbo Stream action for client-side redirects
// Usage: turbo_stream.action(:redirect, target: some_url)
StreamActions.redirect = function() {
  const url = this.getAttribute("target")
  if (url) {
    window.location.href = url
  }
}
